import { useAuthRequiredExecuteCallback } from "@/features/useSearchAction"
import { signalIndexPath } from "@/features_signal/indexPath"
import { PATHS } from "@/router/routes"
import styled from "@emotion/styled"
import { motion } from "motion/react"
import { memo, useCallback } from "react"
import { NavLink, useLocation, useMatch, useNavigate } from "react-router-dom"
import { HomeIcon, InviteIcon, MyIcon, PointsIcon, WelfareIcon } from "./icons"

const NavContainer = styled(motion.nav)`
    position: sticky;
    z-index: 100;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 56rem;
    background: #ffffff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-shadow: 0 -1rem 10rem rgba(0, 0, 0, 0.05);
`

const NavItem = styled(NavLink)`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    gap: 4rem;
    color: #69728c;
    font-size: 10rem;
    flex: 1;

    &.active {
        color: #ff1f57;
    }
`
const NavItemA = styled.a`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    gap: 4rem;
    color: #69728c;
    font-size: 10rem;
    flex: 1;
    cursor: pointer;

    &.active {
        color: #ff1f57;
    }
`
const IconWrapper = styled.div`
    width: 24rem;
    height: 24rem;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        width: 100%;
        height: 100%;
    }
`

function BottomNavigateBar() {
    const location = useLocation()
    const navigate = useNavigate()
    const isActive = (path: string) => location.pathname === path

    const authRequiredExecute = useAuthRequiredExecuteCallback()

    const match_GAME_CATEGORY = useMatch(PATHS.GAME_CATEGORY)

    // 定义不需要显示底部导航的路由
    const hideNavBarPaths = [
        "/login",
        "/loginPassword",
        "/s-game-page",
        "/my/service",
        "/my/news",
        "/bet-record",
        "/s-game/sections",
        "/withdraw-accounts",
        "/s-kyc",
        "/s-vip",
        "/s-vip/level-system",
    ]
    const shouldShowNavBar = !hideNavBarPaths.some((path) => location.pathname.startsWith(path))

    const navigateTo = useCallback(
        (path: string) => async () => {
            await authRequiredExecute(async () => {
                navigate(path)
            })
        },
        [authRequiredExecute, navigate],
    )

    return (
        <NavContainer
            style={{
                display: shouldShowNavBar ? "flex" : "none",
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
        >
            <NavItem
                to={signalIndexPath.value || PATHS.INDEX}
                className={isActive(PATHS.INDEX) || !!match_GAME_CATEGORY ? "active" : ""}
            >
                <IconWrapper>
                    <HomeIcon active={isActive(PATHS.INDEX) || !!match_GAME_CATEGORY} />
                </IconWrapper>
                Home
            </NavItem>
            <NavItemA onClick={navigateTo(PATHS.POINTS)}>
                <IconWrapper>
                    <PointsIcon active={isActive(PATHS.POINTS)} />
                </IconWrapper>
                Points
            </NavItemA>
            <NavItemA onClick={navigateTo(PATHS.WELFARE)}>
                <IconWrapper>
                    <WelfareIcon active={isActive(PATHS.WELFARE)} />
                </IconWrapper>
                Welfare
            </NavItemA>
            <NavItemA onClick={navigateTo(PATHS.INVITE)}>
                <IconWrapper>
                    <InviteIcon active={isActive(PATHS.INVITE)} />
                </IconWrapper>
                Invite
            </NavItemA>
            <NavItemA onClick={navigateTo(PATHS.MY)}>
                <IconWrapper>
                    <MyIcon active={isActive(PATHS.MY)} />
                </IconWrapper>
                My
            </NavItemA>
        </NavContainer>
    )
}

export default memo(BottomNavigateBar)
